import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as accountActions from '../../ducks/account'

class AppContainer extends React.Component {
  render() {
    return React.cloneElement(this.props.children, {
      onChangeLanguage: this.props.actions.changeLanguage,
      currentLanguage: this.props.currentLanguage
    })
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.account.get('currentLanguage')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(accountActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer)



// WEBPACK FOOTER //
// ./src/components/smart/AppContainer.js